// from https://www.xiegerts.com/post/creating-vue-component-library-plugin/

import {defineAsyncComponent} from 'vue';
import '../../../tailwind.css';
import './assets/open-sans.css';
import './assets/material-icons.css';
import * as directiveRegisterFunctions from './directives';
import {
  installSanitize,
  installAxios,
  installAlert,
  installVueI18N,
} from './plugins';
import * as JsYaml from 'js-yaml';
import {GeolocationService, NominatimService} from './api/geolocation';
// Only the outlined variant is used (HitIcon / material-symbols-outlined).
import 'material-symbols/outlined.css';
// Sync: HitTabs matches slot children by type.name === 'HitTab'.
import HitTab from './components/tabs/HitTab.vue';

function translateStringToSnakeCase(s) {
  if (s) {
    return s
      .trim()
      .split(/\.?(?=[A-Z])/)
      .join('_')
      .toLowerCase();
  }
  return null;
}

/** Components that must not be async (parents inspect vnode type.name). */
const SYNC_COMPONENTS = {
  HitTab,
};

function registerAsyncVueComponents(app, modules) {
  for (const [path, loader] of Object.entries(modules)) {
    const name = path.slice(path.lastIndexOf('/') + 1).replace(/\.vue$/, '');
    if (SYNC_COMPONENTS[name]) {
      app.component(name, SYNC_COMPONENTS[name]);
    } else {
      app.component(name, defineAsyncComponent(loader));
    }
  }
}

const HitComponentsVuePlugin = {
  install(app, options = {}) {
    // Lazy: .vue files load only when a template first uses the component.
    registerAsyncVueComponents(app, import.meta.glob('./components/**/*.vue'));
    for (const directiveRegisterFunctionName in directiveRegisterFunctions) {
      const directiveRegisterFunction =
        directiveRegisterFunctions[directiveRegisterFunctionName];
      if (typeof directiveRegisterFunction === 'function') {
        directiveRegisterFunction(app);
      } else {
        console.warn(
          `registrating directive function not a function :  ${directiveRegisterFunction} = ${typeof directiveRegisterFunction}`,
        );
      }
    }

    installSanitize(app);
    if (!options.skipI18n) {
      installVueI18N(app);
    }
    installAxios(app);
    installAlert(app);
    app.config.globalProperties.$geolocation = new GeolocationService({
      geolocationAPI: new NominatimService(),
    });
    app.provide('toSnakeCase', translateStringToSnakeCase);
    window.jsyaml = JsYaml;
  },
};

export {HitComponentsVuePlugin};
export * from './components';
export * from './directives';
export * from './mixins';
export * from './models';
export * from './plugins';
export * from './utils';
